<template>
  <v-container class="agentes-politicos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          icon="mdi-pencil-box-outline"
          sub="Gestão de Agentes Políticos"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="agente.usuario"
        />
        <input
          id="agente-id"
          type="hidden"
          v-model="agente.id"
        />
        <input
          id="agente-uuid"
          type="hidden"
          v-model="agente.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="agente.inativar"
              label="Inativar Agente?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="2"
            class="mr-0 pr-0"
          >
            <v-text-field
              class="codigo mr-0"
              v-model="agente.uid_pessoa"
              label="Código..."
              dense
              outlined
              flat
              @change="loadPedidoPessoaId()"
            >
              <v-icon
                class="v-icon-btn-outer"
                slot="append-outer"
                color="white"
                large
                @click="loadFtPessoa"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="7"
            lg="5"
            class="mx-0 px-0"
          >
            <v-text-field
              class="v-busca-nome ml-0"
              v-model="agente.vereador"
              :loading="loading"
              aria-autocomplete="none"
              :search-input.sync="search"
              label="Nome de batismo"
              outlined
              dense
              @keyup.native="loadSeach()"
            >
              <v-icon
                slot="prepend"
                color="white"
                @click="loadAddPessoa"
                class="v-icon-btn"
                large
              >
                mdi-plus
              </v-icon>
              <v-icon
                v-if="agente.vereador"
                slot="append"
                color="black"
                @click.prevent="clPessoa"
              >
                mdi-close
              </v-icon>
            </v-text-field>
            <v-card
              v-show="listar === 'sim'"
              class="my-0 py-0"
            >
              <ul class="filtro">
                <li
                  v-for="item in items"
                  :key="item.id"
                >
                  <a @click="loadPedidoPessoaId( item, 'novo' )"> {{ item.vereador }}</a>
                </li>
              </ul>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
            lg="2"
          >
            <v-autocomplete
              v-model="agente.uid_partido"
              :items="partidos"
              required
              dense
              outlined
              label="Partido"
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="7"
            lg="5"
          >
            <v-text-field
              v-model="agente.nome"
              type="text"
              label="Nome público"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab>
              <v-icon>
                mdi-account-card-details
              </v-icon>
              Endereço
            </v-tab>
            <v-tab @click="loadTbFones">
              <v-icon>
                mdi-phone
              </v-icon>
              Telefones
            </v-tab>
            <v-tab @click="loadTbRedes">
              <v-icon>
                mdi-chat-plus-outline
              </v-icon>
              Redes sociais
            </v-tab>
            <v-tab @click="loadTbEmails">
              <v-icon>
                mdi-account
              </v-icon>
              E-mails
            </v-tab>
            <v-tab @click="loadTbHistoricos">
              <v-icon>
                mdi-archive
              </v-icon>
              Perfil
            </v-tab>
            <v-tab @click="loadTbFotos">
              <v-icon>
                mdi-camera
              </v-icon>
              Fotos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col
                    cols="11"
                    md="11"
                  >
                    <v-textarea
                      v-model="agente.end_correspondencia"
                      name="endereco"
                      label="Endereço para correspondência"
                      :counter="1000"
                      dense
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Telefones
                      </v-card-title>
                      <v-data-table
                        :headers="headersTelefone"
                        :items="telefones"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadTelefone(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadTelefone(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="adicionarTelefone"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar telefone
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Redes sociais
                      </v-card-title>
                      <v-data-table
                        :headers="headersRedes"
                        :items="redes"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadRede(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadRede(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="adicionarRedes"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar rede social
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        E-mails
                      </v-card-title>
                      <v-data-table
                        :headers="headersEmail"
                        :items="emails"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadEmail(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadEmail(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="adicionarEmail"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar e-mail
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Perfil do Servidor
                      </v-card-title>
                      <v-data-table
                        :headers="headershistorico"
                        :items="historicos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadHistorico(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadHistorico(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          v-if="codigo"
                          cols="12"
                          md="4"
                        >
                          <v-btn
                            color="success"
                            class="ml-2 mb-2"
                            v-if="btn"
                            @click="loadAddHistorico()"
                          >
                            <v-icon left>
                              mdi-account-tie
                            </v-icon>
                            Adicionar Perfil
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Fotos
                      </v-card-title>
                      <v-data-table
                        :headers="headersFoto"
                        :items="fotos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadFoto(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadFoto(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="loadAddFoto"
                          >
                            <v-icon left>
                              mdi-camera
                            </v-icon>
                            Adicionar Foto
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar Servidores
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="agentes"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadVHistorico(item, 'addhistorico')"
                    >
                      mdi-arrow-collapse-down
                    </v-icon>
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadAgente(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadAgente(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="addfoto"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Adicionar e editar Foto</v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="foto.usuario"
                />
                <input
                  id="foto-id"
                  type="hidden"
                  v-model="foto.id"
                />
                <input
                  id="foto-uuid"
                  type="hidden"
                  v-model="foto.uuid"
                />
                <input
                  id="uid_vereador"
                  type="hidden"
                  v-model="foto.uuid_pessoa"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="codigo"
                  >
                    <v-checkbox
                      v-model="foto.inativar"
                      label="Inativar Foto?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="codigo"
                  >
                    <v-checkbox
                      v-model="foto.publico_privado"
                      label="Foto pública ?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-text-field
                      v-model="foto.data_publicacao"
                      v-mask="dtp"
                      label="Data de publicação :"
                      id="dt-publicacao"
                      class="mb-2"
                      :readonly="mode === 'remove'"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="foto.id">
                  <v-col
                    cols="12"
                    lg="8"
                  >
                    <v-text-field
                      v-model="foto.nome_foto"
                      label="Nome da foto ou imagem:"
                      class="mb-2"
                      :readonly="mode === 'remove'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="foto.id">
                  <v-col
                    cols="12"
                    lg="8"
                  >
                    <v-text-field
                      v-model="foto.url_foto"
                      label="Link da foto ou imagem :"
                      class="mb-2"
                      :readonly="mode === 'remove'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="!foto.id">
                  <input
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera"
                    label="Foto do servidor"
                    v-if="uploadReady"
                    type="file"
                    ref="file"
                    @change="selectFile()"
                  >
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="foto.id"
                type="submit"
                @click.prevent="saveFoto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!foto.id"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Upload
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="!foto.id"
                @click="clearUpload"
              >
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click.prevent="closeAddFoto"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addHistorico"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >Perfil dos servidores</v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="historico.usuario"
                  />
                  <input
                    id="historico-id"
                    type="hidden"
                    v-model="historico.id"
                  />
                  <input
                    id="uid_vereador"
                    type="hidden"
                    v-model="historico.uid_pessoa"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="historico.inativar"
                        label="Inativar perfil ?"
                        color="success"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="historico.privado"
                        label="Tornar perfil privado?"
                        color="success"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="historico.ds_historico"
                        label="Título ou Nome"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <VueEditor
                        v-model="historico.historico"
                        placeholder="Sobre servidor ..."
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-center">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="adicionarSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="limpar"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addTelefone"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar telefones
              </v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="telefone.usuario"
                  />
                  <input
                    id="telefone-id"
                    type="hidden"
                    v-model="telefone.id"
                  />
                  <input
                    id="telefone-uuid"
                    type="hidden"
                    v-model="telefone.uid_pessoa"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="telefone.uid_tipo"
                        :items="tipofone"
                        required
                        dense
                        outlined
                        label="Tipo de telefone"
                        @change="loadFuncaoFone()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="telefone.fone"
                        v-mask='msFone'
                        label="Telefone"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-checkbox
                        v-model="telefone.privado"
                        label="Tornar privado ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-checkbox
                        v-model="telefone.whats"
                        label="WhatsApp ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-if="!telefone.id"
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="telefone.data_cadastro"
                        v-mask='dtcad'
                        label="Data do cadastro"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="telefone.icon"
                        :items="iconFone"
                        clearable
                        dense
                        outlined
                        label="Ícone p/ telefone"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="telefone.color"
                        :items="colors"
                        required
                        dense
                        outlined
                        label="Cor do ícone"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="11"
                      md="11"
                    >
                      <v-textarea
                        v-model="telefone.ds_fone"
                        name="historico"
                        label="Observação"
                        :counter="5000"
                        dense
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-center">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="telefone.id"
                  type="submit"
                  @click="updateFone"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!telefone.id"
                  type="submit"
                  @click="adicionarFone"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!telefone.id"
                  type="submit"
                  @click="adicionarFoneSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar e sair
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!telefone.id"
                  @click="limparFone"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addRedes"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar redes sociais
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="rede.usuario"
                />
                <input
                  id="telefone-id"
                  type="hidden"
                  v-model="rede.id"
                />
                <input
                  id="telefone-uuid"
                  type="hidden"
                  v-model="rede.uid_pessoa"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="5"
                    lg="3"
                  >
                    <v-text-field
                      v-model="rede.social"
                      label="Rede social"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="3"
                  >
                    <v-autocomplete
                      v-model="rede.icon"
                      :items="icons"
                      required
                      dense
                      outlined
                      label="Ícone da rede"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-checkbox
                      v-model="rede.privado"
                      label="Tornar privada ?"
                      color="success"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-if="!rede.id"
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-text-field
                      v-model="rede.data_cadastro"
                      v-mask='dtcad'
                      label="Data do cadastro"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-autocomplete
                      v-model="rede.color"
                      :items="colors"
                      required
                      dense
                      outlined
                      label="Cor do ícone"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="11"
                    md="11"
                  >
                    <v-text-field
                      v-model="rede.url_social"
                      name="url"
                      label="Url completa"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-center">
              <v-btn
                color="success"
                class="mr-4"
                v-if="rede.id"
                type="submit"
                @click="updateRede"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!rede.id"
                type="submit"
                @click="adicionarRede"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!rede.id"
                type="submit"
                @click="adicionarRedeSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="!rede.id"
                @click="limparRede"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="limparSair"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addEmail"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar E-mails
              </v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="email.usuario"
                  />
                  <input
                    id="email-id"
                    type="hidden"
                    v-model="email.id"
                  />
                  <input
                    id="email-uuid"
                    type="hidden"
                    v-model="email.uid_pessoa"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-text-field
                        v-model="email.email"
                        label="E-mail"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-checkbox
                        v-model="email.principal"
                        label="Principal ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-checkbox
                        v-model="email.privado"
                        label="E-mail privado ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-if="!email.id"
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="email.data_cadastro"
                        v-mask='dtcad'
                        label="Data do cadastro"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="11"
                      md="11"
                    >
                      <v-textarea
                        v-model="email.ds_email"
                        name="historico"
                        label="Observação"
                        :counter="5000"
                        dense
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-center">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="email.id"
                  type="submit"
                  @click="updateEmail"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!email.id"
                  type="submit"
                  @click="adicionarEmailSave"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!email.id"
                  type="submit"
                  @click="adicionarEmailSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar e sair
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!email.id"
                  @click="limparEmail"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { VueEditor } from 'vue2-editor'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'AgentesPoliticos',
  components: { PageTitle, VueEditor },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    tabs: null,
    btn: false,
    dtp: '##/##/####',
    dtcad: '##/##/####',
    mcel: '(##)#####-####',
    mres: '(##)####-####',
    msFone: '',
    codigo: '',
    dialog: false,
    addfoto: false,
    addTelefone: false,
    addRedes: false,
    addEmail: false,
    addHistorico: false,
    uploadReady: true,
    loading: false,
    search: null,
    select: null,
    file: '',
    tabela: 'pessoas',
    mode: 'save',
    fotouuid: '',
    fotousuario: '',
    listar: '',
    agente: {},
    historico: {},
    email: {},
    telefone: {},
    foto: {},
    rede: {},
    pessoa: {},
    redes: [],
    pessoas: [],
    items: [],
    emails: [],
    telefones: [],
    fotos: [],
    cargos: [],
    historicos: [],
    partidos: [],
    agentes: [],
    length: '',
    tipofone: [],
    iconFone: [
      { value: 'mdi-whatsapp', text: 'WhatsApp' },
      { value: 'mdi-cellphone', text: 'Celular' },
      { value: 'mdi-phone', text: 'Telefone' }
    ],
    icons: [
      { value: 'mdi-facebook', text: 'Facebook' },
      { value: 'mdi-linkedin', text: 'Linkedin' },
      { value: 'mdi-instagram', text: 'Instagram' }
    ],
    colors: [
      { value: 'indigo', text: 'Roxo' },
      { value: 'teal darken-3', text: 'Verde' },
      { value: 'grey darken-4', text: 'Preto' },
      { value: 'red lighten-3', text: 'Vermelho' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'vereador' },
      { text: 'Cpf', value: 'cpf' },
      { text: 'Telefone', value: 'fone' },
      { text: 'Celular', value: 'celular' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headershistorico: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Descrição', value: 'ds_historico' },
      { text: 'Data de inclusão', value: 'dt_inc', sortable: false },
      { text: 'Última atualização', value: 'dt_up', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersTelefone: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Telefone', value: 'fone' },
      { text: 'Tipo', value: 'tipo' },
      {
        text: 'Privado ?',
        value: 'privado',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersRedes: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Rede', value: 'social' },
      { text: 'Url', value: 'url' },
      {
        text: 'Privada ?',
        value: 'privado',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersEmail: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'E-mail', value: 'email' },
      {
        text: 'Principal ?',
        value: 'principal',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Privado ?',
        value: 'privado',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFoto: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url_foto' },
      { text: 'Tam Arq.', value: 'size_foto' },
      { text: 'Data', value: 'data_publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    endereco () {

    },
    fone () {

    },
    histori () {

    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.agente.id ? 'put' : 'post'
      const id = this.agente.id ? `/${this.agente.id}` : ''
      axios[method](`${baseApiUrl}/agentes${id}`, this.agente)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveHistorico () {
      const method = this.historico.id ? 'put' : 'post'
      const id = this.historico.id ? `/${this.historico.id}` : ''
      axios[method](`${baseApiUrl}/historico-dos-agentes${id}`, this.historico)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadHistoricos()
        })
        .catch(showError)
    },
    saveFone () {
      const method = this.telefone.id ? 'put' : 'post'
      const id = this.telefone.id ? `/${this.telefone.id}` : ''
      axios[method](`${baseApiUrl}/telefone-de-pessoas${id}`, this.telefone)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparFone()
          this.loadTelefones()
        })
        .catch(showError)
    },
    saveRede () {
      const method = this.rede.id ? 'put' : 'post'
      const id = this.rede.id ? `/${this.rede.id}` : ''
      axios[method](`${baseApiUrl}/rede-social-de-pessoas${id}`, this.rede)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparRede()
          this.loadRedes()
        })
        .catch(showError)
    },
    saveEmail () {
      const method = this.email.id ? 'put' : 'post'
      const id = this.email.id ? `/${this.email.id}` : ''
      axios[method](`${baseApiUrl}/email-de-pessoas${id}`, this.email)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparEmail()
          this.loadEmails()
        })
        .catch(showError)
    },
    saveFoto () {
      const method = this.foto.id ? 'put' : 'post'
      const id = this.foto.id ? `/${this.foto.id}` : ''
      axios[method](`${baseApiUrl}/foto-de-pessoa${id}`, this.foto)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparFoto()
          this.loadFotos()
          this.addfoto = false
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/foto-pessoas-upload`
      formData.append('uuid', this.fotouuid)
      formData.append('uuid_pessoa', this.pessoas.uuid)
      formData.append('uid_pessoa', this.pessoas.id)
      formData.append('data_publicacao', this.foto.data_publicacao)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pessoas.id)
      formData.append('usuario', this.fotousuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    loadAgentes () {
      const url = `${baseApiUrl}/agentes`
      axios.get(url).then(res => {
        this.agentes = res.data
      })
    },
    loadHistoricos () {
      const idV = this.pessoas.id
      const url = `${baseApiUrl}/historico-do-vereador/${idV}`
      axios.get(url).then(res => {
        this.historicos = res.data.map(item => {
          return {
            ...item,
            dt_inc: moment(item.created_at).format('DD/MM/YYYY'),
            dt_up: moment(item.updated_at).format('DD/MM/YYYY')
          }
        })
        const hs = this.historicos
        if (hs.length === 0) {
          this.btn = true
        }
      })
    },
    loadTelefones () {
      const idF = this.pessoas.id
      const url = `${baseApiUrl}/fone-de-pessoas-por-usuario/${idF}`
      axios.get(url).then(res => {
        this.telefones = res.data
      })
    },
    loadRedes () {
      const idF = this.pessoas.id
      const url = `${baseApiUrl}/rede-social-de-pessoas-por-usuario/${idF}`
      axios.get(url).then(res => {
        this.redes = res.data
      })
    },
    loadEmails () {
      const idE = this.pessoas.id
      const url = `${baseApiUrl}/email-de-pessoas-por-usuario/${idE}`
      axios.get(url).then(res => {
        this.emails = res.data
      })
    },
    loadFotos () {
      const idP = this.pessoas.uuid
      const url = `${baseApiUrl}/foto-por-pessoa/${idP}`
      axios.get(url).then(res => {
        this.fotos = res.data
      })
    },
    loadAgente (item, mode = 'save') {
      this.mode = mode
      this.agente = { ...item }
      this.codigo = this.item.id
      const cod = item.uid_pessoa
      this.dialog = false
      this.valid = true
      this.loadPessoaId(cod)
    },
    loadTelefone (items, mode = 'save') {
      this.mode = mode
      const id = items.id
      const url = `${baseApiUrl}/telefone-update/${id}`
      axios.get(url).then(res => {
        this.telefone = res.data
      })
      this.loadTipoFone()
      this.addTelefone = true
    },
    loadEmail (items, mode = 'save') {
      const id = items.id
      const url = `${baseApiUrl}/email-update/${id}`
      axios.get(url).then(res => {
        this.email = res.data
      })
      this.mode = mode
      this.addEmail = true
    },
    loadRede (items, mode = 'save') {
      const id = items.id
      const url = `${baseApiUrl}/rede-social-de-pessoas-up/${id}`
      axios.get(url).then(res => {
        this.rede = res.data
      })
      this.mode = mode
      this.addRedes = true
    },
    loadFoto (items, mode = 'save') {
      const id = items.id
      const url = `${baseApiUrl}/fotos-de-pessoas-up/${id}`
      axios.get(url).then(res => {
        this.foto = res.data
      })
      this.mode = mode
      this.addfoto = true
    },
    loadVHistorico (item, mode = 'addhistorico') {
      this.mode = mode
      this.agente = { ...item }
      this.codigo = this.agente.id
      this.loadHistoricos()
      this.dialog = false
    },
    loadAddHistorico () {
      this.historico.uid_pessoa = this.pessoas.id
      this.historico.usuario = this.user.id
      this.addHistorico = true
      this.valid = false
    },
    loadPedidoPessoaId (item) {
      const id = this.agente.uid_pessoa ? `/${this.agente.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/vereador-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.agente.uid_pessoa = this.pessoa.uid_pessoa
        this.agente.vereador = this.pessoa.vereador
        this.agente.cpf = this.pessoa.cpf
        this.agente.cpf_txt = this.pessoa.cpf_txt
      })
      this.clPessoa()
    },
    loadPessoaId (cod) {
      const id = cod
      const url = `${baseApiUrl}/adm-adm-pessoas-por-id/${id}`
      axios.get(url).then(res => {
        this.pessoas = res.data
      })
      this.btn = false
    },
    clPessoa () {
      this.agente.uid_pessoa = ''
      this.agente.vereador = ''
      this.agente.cpf = ''
      this.agente.cpf_txt = ''
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.agente.vereador || 0
      const url = `${baseApiUrl}/vereador-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {

    },
    loadHistorico (items, mode = 'save') {
      const idV = items.id
      const url = `${baseApiUrl}/historico-do-vereador-for-up/${idV}`
      axios.get(url).then(res => {
        this.historico = res.data
      })
      this.mode = mode
      this.addHistorico = true
    },
    loadTbFones () {
      this.loadTelefones()
    },
    loadTbRedes () {
      this.loadRedes()
    },
    loadTbEmails () {
      this.loadEmails()
    },
    loadTbHistoricos () {
      this.loadHistoricos()
    },
    loadTbFotos () {
      this.loadFotos()
    },
    adicionarTelefone () {
      this.loadTipoFone()
      this.telefone.usuario = this.user.id
      this.telefone.uid_pessoa = this.pessoas.id
      this.addTelefone = true
    },
    adicionarRedes () {
      this.rede.usuario = this.user.id
      this.rede.uid_pessoa = this.pessoas.id
      this.addRedes = true
    },
    adicionarEmail () {
      this.email.usuario = this.user.id
      this.email.uid_pessoa = this.pessoas.id
      this.addEmail = true
    },
    loadFuncaoFone () {
      let tp = this.telefone.uid_tipo
      if (tp === 1) {
        this.msFone = this.mcel
      } else if (tp === 2) {
        this.msFone = this.mres
      }
    },
    reset () {
      this.valid = false
      this.btn = false
      this.codigo = ''
      this.mode = 'save'
      this.pessoas = []
      this.agente = {}
      this.historicos = []
      this.telefones = []
      this.redes = []
      this.emails = []
    },
    limpar () {
      this.valid = false
      this.mode = 'save'
      this.historico = {}
    },
    limparFone () {
      this.mode = 'save'
      this.telefone = {}
    },
    limparRede () {
      this.mode = 'save'
      this.rede = {}
    },
    limparSair () {
      this.mode = 'save'
      this.rede = {}
      this.addRedes = false
    },
    limparEmail () {
      this.mode = 'save'
      this.email = {}
    },
    limparFoto () {
      this.mode = 'save'
      this.foto = {}
    },
    closeAddFoto () {
      this.foto = {}
      this.addfoto = false
    },
    adicionarSair () {
      this.saveHistorico()
      this.addHistorico = false
    },
    adicionarFone () {
      this.saveFone()
    },
    adicionarFoneSair () {
      this.saveFone()
      this.addTelefone = false
    },
    updateFone () {
      this.saveFone()
      this.addTelefone = false
    },
    adicionarRede () {
      this.saveRede()
    },
    adicionarRedeSair () {
      this.saveRede()
      this.addRedes = false
    },
    updateRede () {
      this.saveRede()
      this.addRedes = false
    },
    adicionarEmailSave () {
      this.saveEmail()
    },
    adicionarEmailSair () {
      this.saveEmail()
      this.addEmail = false
    },
    updateEmail () {
      this.saveEmail()
      this.addEmail = false
    },
    loadDialog () {
      this.dialog = true
      this.loadAgentes()
    },
    loadAddFoto () {
      this.fotouuid = uuid.v1()
      this.fotousuario = this.user.id
      this.addfoto = true
    },
    loadTipoFone () {
      const url = `${baseApiUrl}/tipo-de-telefones`
      axios.get(url).then(res => {
        this.tipofone = res.data.map(tipofone => {
          return {
            value: tipofone.id,
            text: `${tipofone.tipo}`
          }
        })
      })
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data.map(cargos => {
          return {
            value: cargos.id,
            text: `${cargos.funcao_nome}`
          }
        })
      })
    },
    loadPartidos () {
      const url = `${baseApiUrl}/partidos`
      axios.get(url).then(res => {
        this.partidos = res.data.map(partidos => {
          return {
            value: partidos.id,
            text: `${partidos.partido}`
          }
        })
      })
    },
    loadUser () {
      this.agente.usuario = this.user.id
      this.agente.uuid = uuid.v1()
    }
  },
  mounted () {
    this.loadUser()
    this.loadPartidos()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
